import { Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Tournament } from '../models/tournament';
@Injectable({
  providedIn: 'root'
})
export class TournamentService {
  public tournament = signal<Tournament | undefined>(undefined);
  public tournamentSection = signal<string>('');

  constructor(
    private httpClient: HttpClient,
  ) { }

  // set tournament (in detail) signal
  private setTournament(value: Tournament) {
    this.tournament.set(value);
  }

  // set tournament section signal
  public setTournamentSection(value: string) {
    this.tournamentSection.set(value);
  }

  // [GET] active tournaments
  public getActiveTournaments(type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/active`, {
        params: {}, observe: 'response'
      });
  }

  // [GET] finished tournaments
  public getFinishedTournaments(type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/finished`, {
        params: {}, observe: 'response'
      });
  }

  // [GET] tournament (&& set signal)
  public getTournament(id: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>(
      environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/${id}`,
      { params: {}, observe: 'response' }
    ).pipe(
      map(res => res.body ?? {}),
      tap(tournament => this.setTournament(tournament))
    );
  }

  // [POST] create tournament
  public createTournament(tournament: Tournament, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.tournaments, ':type', type), tournament, {
        params: {}, observe: 'response'
      });
  }

  // [PATCH] update tournament
  public updateTournament(tournament: Tournament, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/${tournament.id}`,
      tournament, { params: {}, observe: 'response' });
  }

  // [DELETE] delete tournament
  public deleteTournament(tournament: Tournament, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':id', tournament.id]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentsDelete
    );
    return this.httpClient.delete<HttpResponse<object>>
      (environment.api_server + apiEndpoint,
      { params: {}, observe: 'response' });
  }

  // [PATCH] archive tournament
  public archiveTournament(tournament: Tournament, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.patch<HttpResponse<object>>
      (environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/${tournament.id}/archive`,
      tournament, { params: {}, observe: 'response' });
  }

  // [POST] create tournament for development
  public createTournamentDev(type: string = 'chess'): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + `${_.replace(environment.api_endpoints.tournaments, ':type', type)}/seed`, {}, {
        params: {}, observe: 'response'
      });
  }
}
